export default "__VITE_ASSET__m$ILFbtY__"